<template>
    <div class="screen-print">
        <div class="screen-print__toggle-switch">
            <input class="screen-print__toggle-switch-input" type="radio" id="screen-print__toggle-switch-1" value="1" v-model="step" name="toggle" />
            <label class="screen-print__toggle-switch-label" for="screen-print__toggle-switch-1" :class="{ active: step === '1' }">
                {{ getTranslatedText('Select Printer') }}
            </label>

            <input class="screen-print__toggle-switch-input" type="radio" id="screen-print__toggle-switch-2" value="2" v-model="step" name="toggle" />
            <label class="screen-print__toggle-switch-label" for="screen-print__toggle-switch-2" :class="{ active: step === '2' }">
                {{ getTranslatedText('Use Inner-Printer') }}
            </label>

            <span class="screen-print__toggle-switch-glider"></span>
        </div>

        <template v-if="step === '1'">
            <h5 class="screen-print__title-list">
                {{ getTranslatedText('Printers') }}
            </h5>
            <LoadingScreen v-if="isLoadingScreen" />
            <div v-else-if="isCheckPermissions" class="screen-print__permissions">
                <span class="screen-print__permissions-text">
                    {{ getTranslatedText('Please allow bluetooth permission!') }}
                </span>
                <a class="screen-print__permissions-text screen-print__permissions-text-link" @click="onGoToSetting">
                    {{ getTranslatedText('Go to Settings') }}
                </a>
            </div>
            <template v-else>
                <div class="screen-print__device" v-if="$store.state.listBluetooth.length > 0">
                    <div class="screen-print__device-list">
                        <div class="screen-print__device-item" v-for="(v, i) in $store.state.listBluetooth" :key="i">
                            <span class="screen-print__text">{{ v.name }}</span>
                            <ButtonCommon
                                :isLoading="isLoadingButton"
                                :value="$store.state.defaultPrinter === v.address ? `SELECTED` : `Select`"
                                @on-click-button-common="() => onCheckConnectBluetooth(v)"
                            />
                        </div>
                    </div>
                    <span class="screen-print__text">
                        {{ getTranslatedText(`Go to device's Bluetooth Setting to add more printer if your  device is not here.`) }}
                    </span>
                </div>
                <div class="screen-print__device-empty" v-else>
                    <span class="screen-print__text">
                        {{ getTranslatedText('Found no printer!') }}
                    </span>
                    <span class="screen-print__text">
                        {{ getTranslatedText(`Go to device's Bluetooth Setting to add printer.`) }}
                    </span>
                </div>
            </template>
            <div class="screen-print__box-button">
                <ButtonCommon
                    :isNoHover="true"
                    :isLoading="isLoadingButton"
                    icon="refresh"
                    type="outline"
                    className="w100"
                    value="Refresh printer list"
                    @on-click-button-common="onRefreshPrinterList"
                />
                <ButtonCommon
                    :isNoHover="true"
                    :isLoading="isLoadingButton"
                    type="active"
                    className="w100"
                    icon="print"
                    value="test print"
                    @on-click-button-common="onTestPrint"
                />
            </div>
        </template>
        <template v-else>
            <span class="screen-print__text text-turn">{{ getTranslatedText(`try to turn on bluetooth so inner-printer can work properly`) }}</span>
            <div class="screen-print__box-button">
                <ButtonCommon
                    :isNoHover="true"
                    :isLoading="isLoadingButton"
                    type="active"
                    className="w100"
                    icon="print"
                    value="test print"
                    @on-click-button-common="onTestPrint"
                />
            </div>
        </template>
    </div>
</template>
<script>
import ButtonCommon from '@/components/common/button/button.vue';
import LoadingScreen from '@/components/common/loading/loading.vue';

import languageMixins from '@/mixins/language-mixins';
import printMixins from '@/mixins/print-mixins';
import utilsMixin from '@/mixins/function-utils';

import EventBus from '@/utils/EventBus';

import { capitalizeFirstLetter, isObjEmpty, isStrEmpty } from '@/utils/utils';

export default {
    mixins: [languageMixins, printMixins, utilsMixin],
    components: { ButtonCommon, LoadingScreen },
    data() {
        return {
            step: '1',
            dataSource: [],
            isLoadingScreen: false,
            isLoadingButton: false,
            isCheckPermissions: false,
        };
    },
    watch: {
        step(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.step = newValue;
            }
        },
    },
    mounted() {
        document.addEventListener('message', this.handleMessage);
    },
    unmounted() {
        document.removeEventListener('message', this.handleMessage);
    },
    methods: {
        handleMessage(event) {
            const resp = JSON.parse(event.data);
            if (resp.command === 'is-loading-get-bluetooth') {
                this.isLoadingScreen = false;
                this.isLoadingButton = false;
            }

            if (resp.command === 'show-error-connect-print') {
                const param = {
                    text: resp.message,
                    type: 'error',
                };
                EventBus.emit('show-notications', param);
                this.isLoadingButton = false;
            }

            if (resp.command === 'connect-bluetooth-success') {
                this.isLoadingButton = false;
                const param = {
                    id: resp.data,
                    isBluetooth: !isStrEmpty(resp.data),
                };
                this.$store.commit('SET_IS_BLUETOOTH', param);
            }

            if (resp.command === 'go-to-settings') {
                this.isCheckPermissions = resp.param;
            }
        },

        onRefreshPrinterList() {
            const setting = this.$store.state.configDevice;
            const setup = this.$store.state.config.setup;

            parent.postMessage({ command: 'get-list-bluetooth' }, '*');
            this.isLoadingScreen = true;
            this.isLoadingButton = true;
            const param = {
                id: '',
                isBluetooth: false,
            };
            this.$store.commit('SET_IS_BLUETOOTH', param);
            if (setup.isTestingBrowers && isObjEmpty(setting)) {
                this.isLoadingScreen = false;
                this.isLoadingButton = false;
            }
        },

        onCheckConnectBluetooth(v) {
            if (this.$store.state.defaultPrinter === v.address) {
                this.onDisconnectBluetooth(v);
            } else {
                this.onClickConnectBluetooth(v);
            }
        },

        onDisconnectBluetooth(v) {
            parent.postMessage({ command: 'disconnect-bluetooth', param: v.address }, '*');
        },

        onClickConnectBluetooth(v) {
            this.isLoadingButton = true;
            parent.postMessage({ command: 'connect-bluetooth', param: v.address }, '*');
        },

        onGoToSetting() {
            parent.postMessage({ command: 'on-go-to-settings' }, '*');
        },

        onTestPrint() {
            this.isLoadingButton = true;

            let code = this.getParamQueryTheme('code');
            code = capitalizeFirstLetter(code);
            let param = {
                cashier_name: 'Cashier1 Cashier1 - 1',
                branch_name: `${code} Branch 1`,
                currency_code: 'BIF',
                winnings: 446.8,
                code: 'S-PX4YNPQYF',
                date: new Date(),
                amount: 446.8,
                isTestPrint: true,
            };
            this.printSettle(param);
            this.isLoadingButton = false;
        },
    },
};
</script>
<style lang="scss">
@import '@/public/scss/print/print.scss';
</style>
